import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../lib/useOnlineStatus';

/** Shown on screens whose actions need the cloud; renders nothing while online. */
export const OnlineOnlyNotice = ({ feature, detail, testId = 'online-only-notice', dark = false }) => {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status" aria-live="polite" data-testid={testId}
      className={`flex items-start gap-2 rounded-lg border px-3 py-2 text-sm ${dark
        ? 'border-amber-400/40 bg-amber-400/10 text-amber-200'
        : 'border-amber-300 bg-amber-50 text-amber-800'}`}
    >
      <WifiOff className="h-4 w-4 mt-0.5 shrink-0" aria-hidden="true" />
      <span>
        <strong>{feature} needs internet.</strong>{' '}
        {detail || 'You are working offline. Reconnect to use this, nothing here is saved until then.'}
      </span>
    </div>
  );
};
